export enum ANALYTICS_EVENT {
  WALLET_CONNECT = "wallet connect",
  CLICKED_ON_STAKING_DAPP = "clicked on staking dApp",
  CLICKED_ON_AGGREGATOR_DAPP = "clicked on aggregator dApp",
}
